var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.Is,{tag:"component",attrs:{"value":_vm.value,"config":_vm.config,"title":_vm.title,"options":_vm.options,"icon":_vm.icon},on:{"change":_vm.handleChange,"click":_vm.handleClick}},[_vm._t("default"),_vm._t("button",null,{"slot":"button"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }